import React from 'react';
import { type Control } from 'react-hook-form';

import Select from '@components/uikit/Select/Select';
import Tabs from '@components/uikit/Tabs/Tabs';

import { DATETIME_FORMATS } from '@constants/datetimeFormats';

import useTranslation from '@hooks/useTranslation';

import { PROFILE_FIELDS } from '@pages/Profile/constants/schemaProfile';

import DataUnitsInfoSkeleton from './DataUnitsInfoSkeleton';
import style from './style.module.scss';

interface IProps {
  isLoading: boolean;
  control: Control<any>;
  reloadTimeoutList: Array<{ value: number; name: string }>;
}

const DataUnitsInfo: React.FC<IProps> = ({ isLoading, control, reloadTimeoutList }) => {
  const { t } = useTranslation();

  const metricsList = [
    { value: 0, label: t('Metric (mm, mm/sec, °C)') },
    { value: 1, label: t('US (mils, in/sec, °F)') },
  ];

  const dateTimeList = [
    { value: DATETIME_FORMATS.us.dateTime, label: t('MM/DD/YY HH:mm:ss') },
    { value: DATETIME_FORMATS.common.dateTime, label: t('DD/MM/YY HH:mm:ss') },
  ];

  return (
    <div className={style.unitsInfo}>
      <div className={style.unitsInfoTitle}>{t('Data and Units')}</div>
      {isLoading ? (
        <DataUnitsInfoSkeleton />
      ) : (
        <div className={style.unitsInfoFields}>
          <Select
            name={PROFILE_FIELDS.REFRESH_INTERVAL}
            control={control}
            label={t('Reload data interval')}
            options={reloadTimeoutList}
            itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'name' }}
            type="woHelperText"
          />
          <div className={style.tabFieldsWrapper}>
            <Tabs
              label={t('Date format')}
              id={PROFILE_FIELDS.DATETIME_FORMAT}
              control={control}
              name={PROFILE_FIELDS.DATETIME_FORMAT}
              tabsItems={dateTimeList}
              type={'woHelperText'}
            />
            <Tabs
              label={t('Measurement units')}
              id={PROFILE_FIELDS.USE_METRIC}
              control={control}
              name={PROFILE_FIELDS.USE_METRIC}
              tabsItems={metricsList}
              type={'woHelperText'}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DataUnitsInfo;
